import {useState} from "react";
import {navigateToDetail, buildDetailUrl} from "../../Utils/utils";
import DifficultyPill from "../../../SportRouteDetail/components/DifficultyPill/DifficultyPill";
import SportRouteStar from "../../../SportRouteDetail/components/SportRouteStar";
import {scoreToOutOfFive} from "../../Utils/utils";

export const RouteListItem = (props) => {
    const {route, linkText, redirectRoute, isOverview, dictionary} = props;

    const convertTypeToIcon = () => {
        let image = "";
        let baseUrl = "/images/listviewIcons";
        let suffix = ".svg";
        switch (route.type) {
            case 9:
            case 25:
            case 26:
            case 49:
                image = `${baseUrl}/runIcon${suffix}`;
                break;

            case 17:
            case 35:
            case 36:
                image = `${baseUrl}/horsebackIcon${suffix}`;
                break;

            case 7:
                image = `${baseUrl}/mountainbikeIcon${suffix}`;
                break;

            case 47:
                image = `${baseUrl}/gravelbikeIcon${suffix}`;
                break;

            case 16:
            case 32:
                image = `${baseUrl}/kayakIcon${suffix}`;
                break;

            case 19:
                image = `${baseUrl}/skateIcon${suffix}`;
                break;
            case 2:
            case 8:
                image = `${baseUrl}/multiMoveIcon${suffix}`;
                break;
        }
        return image;
    };

    return (
        <a
            className={`c-routelistItem__container`}
            href={buildDetailUrl(route.id, window, redirectRoute)}
            onClick={(e) => {
                e.preventDefault();
                navigateToDetail(route.id, window, redirectRoute);
            }}
        >
            <img className="c-routelistItem__img" src={`${route.imageUrl}`} />
            <div className="c-routelistItem-routedetail__container">
                <h4 className="c-routelistItem-routedetail-content__big-text title">
                    {route.name}
                </h4>
                <div className="c-routelistItem-routedetail-content__container">
                    <img
                        className="c-routelistItem-routedetail__icon"
                        src={convertTypeToIcon(route.type)}
                    />
                    <div className="c-routelistItem-routedetail-content-text__container">
                        <i className="fa-solid fa-arrows-up-down c-routelistItem-distance-icon"></i>
                        <p>{route.distance?.toFixed(2)}km</p>
                    </div>
                    <div className="c-routelistItem-routedetail-content-text__container">
                        <i className="fa-solid fa-arrow-up c-routelistItem-elevation-icon"></i>
                        <p>{route.elevation?.toFixed(0)}m</p>
                    </div>
                </div>

                <div className="c-routelistItem-routedetail-content__container">
                    <DifficultyPill
                        difficultyScore={route.difficultyAuthor ?? route.difficulty}
                        dictionary={dictionary}
                    />
                    <strong className="c-routelistItem-routedetail-content-score__container">
                        <SportRouteStar filled={true} />
                        {route.reviewScore && scoreToOutOfFive(route.reviewScore)}
                    </strong>
                </div>

                <div className="c-routelistItem-routedetail-redirect__container">
                    <i className="fal fa-arrow-right"></i>
                    <span className="c-routelistItem-routedetail-redirect__text">{linkText}</span>
                </div>
            </div>
        </a>
    );
};